{
    "productImageZoomTrigger":{
       "expand":""
    },
    "productImageZoomDialog":{
       "close":"Afbreken"
    }
 }